import React, { useState, useEffect } from 'react';
import { TextField, Button, Checkbox } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { getAccessRightsForPageID, client, checkValidSession, getToken, getAdminID, actionGetIssuerConfig } from "../store/action/RemoteActionSupervisor";
import { resetTimout } from "./common/FirebaseSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";
import { PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";

let SERVERAPI_URL = process.env.REACT_APP_SERVER_URL_API;

const IssuerConfiguration = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [selectedClient, setSelectedClient] = useState({});
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isModifed, setIsModifed] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false); //Trigger page rendering
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);

    const handleChange = (e) => {
        resetTimout();
        if (pageAccessRights.WriteAccess !== ACCESSRIGHTSTYPE.Yes) {
            return;
        }
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "id_AdminPasswordExpiry":
                selectedClient.AdminPasswordExpiry = eventValue.replace(/[^0-9]/g, "");
                break;
            default:
                console.log(e.target.name);
        }
        setChangeStatus(!changeStatus);
        setIsModifed(true);
        setIsSubmitSuccess(false);
    };

    const submitModifyClient = async () => {
        const regexEmail = /^[a-z0-9_.@]+$/i;
        if (!checkValidSession()) {
            return;
        }

        if (!isModifed) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (!selectedClient.AdminPasswordExpiry) {
            alert(getMultiLanguageMessage('msg_Incomplete_Input_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            let requestBody = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: getAdminID(),
                ClientID: selectedClient.ClientID,
                AdminPasswordExpiry: selectedClient.AdminPasswordExpiry
            };
            setIsButtonClicked(true);
            if (!checkValidSession()) {
                return;
            }

            await client(getToken()).put(`${SERVERAPI_URL}/vfaspclient/issuer/update`, requestBody).then((response) => {
                if (response.status == 200) {
                    setIsSubmitSuccess(true);
                    setIsModifed(false);
                } else {
                    alert(getMultiLanguageMessage('msg_Server_Error', language));
                    setIsSubmitSuccess(false);
                }
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
            });
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.issuerConfig?.ClientID?.length > 0) {
            setSelectedClient(props?.issuerConfig);
        }
    }, [props.issuerConfig]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.Vfasp);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
            props.actionGetIssuerConfig();
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((selectedClient?.ClientID?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) ?
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-IssuerConfiguration')}</h2>

            {/* .nav-tabs-line */}
            <div className="tab-content" id="security-opt-tab">
                {/* .tab-pane */}
                <div className="tab-pane active show" id="password-opt">
                    <form action="#">
                        {/* .row */}

                        <table width='100%'>
                            <tbody>
                                <tr>
                                    <td className='td-type2-col1'>{translate('SupervisorPasswordExpiryDays')} <span className='Message-Red'>*</span></td>
                                    <td className='td-type2-col2'>
                                        <TextField size="small" id="id_AdminPasswordExpiry" name="id_AdminPasswordExpiry" sx={{ width: '10ch' }} value={selectedClient.AdminPasswordExpiry} onChange={handleChange} />
                                        &nbsp;{translate('Days')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {isSubmitSuccess &&
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <div className="gaps-2x d-sm-none" />
                                <span className="color-success">
                                    <div>
                                        <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                        <div className="gaps-1x" />
                                    </div>
                                </span>
                            </div>
                        }

                        {(pageAccessRights && pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes) &&
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => submitModifyClient()}>{translate('btnUpdate')}</Button>
                                <div className="gaps-2x d-sm-none" />
                            </div>
                        }
                    </form>
                    {/* form */}
                </div>
                {/* .tab-pane */}
            </div>
            {/* .tab-content */}
        </div>
        : "");
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        issuerConfig: state.remote.issuerConfig
    };
};

export default connect(mapStateToProps, {
    actionGetIssuerConfig
})(IssuerConfiguration);
